import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "icon"]

  connect() {
    this.open = false
    this.timeout = null
  }

  toggle(event) {
    event.stopPropagation()
    this.open = !this.open
    this.update()
  }

  show() {
    clearTimeout(this.timeout)
    this.open = true
    this.update()
  }

  hide() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.open = false
      this.update()
    }, 200)
  }

  cancelHide() {
    clearTimeout(this.timeout)
  }

  forceHide() {
    clearTimeout(this.timeout)
    this.open = false
    this.update()
  }

  update() {
    this.menuTarget.classList.toggle("hidden", !this.open)

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180", this.open)
    }
  }
}
